// extracted by mini-css-extract-plugin
module.exports = {"contentWrap":"EventFeed_contentWrap__2LOki","eventSmallListWrapper":"EventFeed_eventSmallListWrapper__3YKyp","eventSmallWrapper":"EventFeed_eventSmallWrapper__3glc8"};